import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { ICheckBoxViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';

/**
 * Das ViewModel für die CheckBox
 */
export default class CheckBoxViewModel extends ControlViewModel {

    /**
     * Gibt an, ob die CheckBox angehakt ist
     */
    public isChecked: KnockoutObservable<boolean>;

    /**
     * Ein optionaler Wert für die CheckBox
     */
    public value: KnockoutObservable<boolean | string>;

    /**
     * Ein Handler, der aufgerufen wird, wenn die CheckBox (oder das Label) angeklickt wird
     */
    public onClick: Function;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die CheckBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ICheckBoxViewModelConstructorParameter) {
        super(params);
        this.isChecked = this.observableOrDefault(params.isChecked, false);
        this.value = this.observableOrDefault(params.value, null);
        this.onClick = this.handlerOrDefault(params.onClick);
        this.label = this.paramOrDefault(params.label, null);
    }

    /**
     * Eine Methode, zum Ändern der zuletzt durchgeführten Aktion
     */
    public revert(): void {
        let isChecked = this.isChecked();
        this.isChecked(!isChecked);
    }

    /**
     * Eine Methode zum Wechseln des Zustands, falls das isEnabled() == true
     */
    public toggleIfEnabled(): void {
        if (this.isEnabled()) {
            this.revert();
        }
    }

    public resetValue(): void {
        this.isChecked(false);
    }
}

ComponentManager.setViewModel('CheckBoxViewModel', CheckBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');